// Arabic UI dictionary. Keys are the English source strings used in t('...').
import auth from './auth';
import dashboard from './dashboard';
import tour from './tour';
import components from './components';
import settings from './settings';
import editor from './editor';

const ar = {
  ...auth,
  ...dashboard,
  ...tour,
  ...components,
  ...settings,
  ...editor,
};

export default ar;
